module.exports = __webpack_public_path__ + "media/images/training_case12-60a029df31e503bb6f2f9899fcfd7b51.jpg";